import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { Analytics } from '@vercel/analytics/react';

/* Vista previa de paletas: ?paleta=nombre (ver styles.css, [data-palette]) */
const paleta = new URLSearchParams(window.location.search).get('paleta');
if (paleta) document.documentElement.dataset.palette = paleta;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
        <Analytics />
    </React.StrictMode>
);
